import {IPaginationMetadata} from '../shared/interfaces'

export enum CorrespondenceParticipantRole {
  Financier = 1,
  Analyst = 2,
  Manager = 3,
  Admin = 4,
  GrantProvider = 5,
}

export const INTERNAL_PARTICIPANT_ROLES = [
  CorrespondenceParticipantRole.Analyst,
  CorrespondenceParticipantRole.Manager,
  CorrespondenceParticipantRole.Admin,
]

export enum CorrespondenceThreadStatus {
  Open = 1,
  Closed = 2,
  Archived = 3,
}

export enum CorrespondenceMessageType {
  External = 1,
  Internal = 2,
}

export interface ICorrespondenceParticipant {
  id: string
  userId: string
  displayName: string
  email?: string | null
  role: CorrespondenceParticipantRole
  isActive: boolean
  isDeleted?: boolean
}

export interface IMessageReadBy {
  participantId: string
  displayName: string
  readAt: string
}

export interface ICorrespondenceMessage {
  id: string
  threadId: string
  authorId: string
  authorName: string
  body: string
  messageType: CorrespondenceMessageType
  parentMessageId?: string | null
  isReadByCurrentUser: boolean
  readAt?: string | null
  readBy: IMessageReadBy[]
  attachments: ICorrespondenceAttachment[]
  dateCreated: string
  dateUpdated: string
}

export interface ICorrespondenceAttachment {
  id: string
  documentAssetId: string
  fileName: string
  fileType: string
  fileSize: number
}

export interface ICreateCorrespondenceAttachment {
  documentAssetId: string
  fileName: string
  fileType: string
  fileSize: number
}

export interface ICorrespondenceThread {
  id: string
  financierId?: string | null
  subject?: string | null
  status: CorrespondenceThreadStatus
  sourceService?: string | null
  relatedEntityType?: string | null
  relatedEntityId?: string | null
  lastMessageAt?: string | null
  lastMessageBody?: string | null
  lastMessageAuthorName?: string | null
  hasUnread: boolean
  isBroadcast?: boolean
  isArchivedForCurrentUser: boolean
  archivedAtForCurrentUser?: string | null
  dateCreated: string
  dateUpdated: string
  participants: ICorrespondenceParticipant[]
}

export interface ICorrespondenceThreadDetail extends ICorrespondenceThread {
  messages: ICorrespondenceMessage[]
}

export interface ISearchCorrespondenceThreads {
  page?: number
  pageSize?: number
  financierId?: string
  participantUserId?: string
  participantRole?: CorrespondenceParticipantRole
  isArchived?: boolean
  status?: CorrespondenceThreadStatus
  sourceService?: string
  relatedEntityType?: string
  relatedEntityId?: string
}

export interface ICreateCorrespondenceParticipant {
  userId: string
  displayName: string
  email?: string | null
  role: CorrespondenceParticipantRole
}

export interface ICreateCorrespondenceThread {
  financierId?: string | null
  subject?: string | null
  sourceService?: string | null
  relatedEntityType?: string | null
  relatedEntityId?: string | null
  participants: ICreateCorrespondenceParticipant[]
  initialMessage: ICreateCorrespondenceMessage
}

export interface ICreateCorrespondenceMessage {
  body: string
  messageType: CorrespondenceMessageType
  parentMessageId?: string | null
  attachments?: ICreateCorrespondenceAttachment[]
}

export interface ICreateBroadcastThread {
  subject?: string | null
  participants: ICreateCorrespondenceParticipant[]
  initialMessage: ICreateCorrespondenceMessage
}

export interface IMarkThreadAsReadResponse {
  messagesMarkedAsRead: number
}

export interface IUnreadCountResponse {
  total: number
}

export interface ICorrespondenceBackendPagination {
  totalItems: number
  pageSize: number
  currentPage: number
  totalPages: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export interface ISearchCorrespondenceThreadsResponse {
  data: ICorrespondenceThread[]
  paginationMetadata: IPaginationMetadata
}